import styled from "styled-components";

export const TravelPlexBotWrapper = styled.div`
  & .myraFloatingBar {
    bottom: 100px !important;
  }
`;
